export default __webpack_public_path__ + "static/media/image-33.cf781785.png";